<shared-test-api-endpoint-notification></shared-test-api-endpoint-notification>
<div id="page-container">
  <div id="content-wrap">
    <router-outlet></router-outlet>
  </div>
</div>
